import { AbstractControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';

interface ControlNameTranslatorFn {
  (controlName: string): string;
}

export type ValidationErrorAtLeastOne = {
  controls: string[];
  translated?: string[];
};

export class FormGroupValidators {
  /**
   * Requires that at least one control in a form group has a non-empty value.
   * @param options (TODO)
   * @returns
   */
  static atLeastOne(options?: {
    controls?: string[];
    validator?: ValidatorFn;
    controlNameTranslator?: ControlNameTranslatorFn;
  }): ValidatorFn {
    return (group: AbstractControl): { atLeastOne: ValidationErrorAtLeastOne } | null => {
      const controls = (group as FormGroup)?.controls;
      if (!controls) {
        console.warn('Incorrect usage of atLeastOne validator. Can only be used on FormGroups.');
        return null;
      }

      const validator = options?.validator ?? Validators.required;
      const keys = options?.controls ?? Object.keys(controls);

      if (!keys.length) {
        console.warn('Validator atLeastOne was used on an empty form group selection. Ignoring.');
        return null;
      }

      const isAnyOk = keys.some(x => !validator(controls[x]));
      if (isAnyOk) {
        return null;
      }

      let names;
      if (options?.controlNameTranslator) {
        try {
          names = keys.map(x => options.controlNameTranslator(x));
        } catch (err) {
          console.warn('Failed to translate control names for atLeastOne validator.');
          console.debug(err);
        }
      }

      return {
        atLeastOne: { controls: keys, translated: names },
      };
    };
  }
}
